import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    cardSplitButton: {
      margin: theme.spacing(0, 2, 0, 0)
    }
  })
